export default {
  methods: {
    isValidNumber(number) {
      return !Number.isNaN(number) && number !== null && number !== undefined;
    },
    toLocaleString(number, withDecimals = false) {
      if (!this.isValidNumber(number)) return '-';
      return withDecimals ? number.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
        : number.toLocaleString();
    },
    convertNumberToString(number) {
      return number && number < 10 ? `0${number}` : number;
    },
    isValidInteger(value) {
      return /^[+-]?\d+$/.test(value);
    },
    isValidRealNumber(value) {
      return /^[+-]?\d+(\.\d+)?$/.test(value);
    },
    removeLeadingZeros(number) {
      return number.match(/0$|(?!0)\d+/g);
    },
    isNumberInRange(number, min, max) {
      if (!this.isValidRealNumber(number)
          || !this.isValidRealNumber(min)
          || !this.isValidRealNumber(max)) throw new TypeError('Values must be numbers or strings of numbers');
      return number >= min
          && number <= max;
    },
  },
};
